import * as React from "react";

export const FullGridPage: React.FunctionComponent<ReactProps> = props => {
  return <div className="ag-grid-content-page">{props.children}</div>;
};
